import { string } from 'prop-types';
import { path, propOr } from 'ramda';
import { compose, setDisplayName, setPropTypes, withStateHandlers } from 'recompose';
import { withPropsForFolderPath } from '../../../../../containers/FilesImporter/components/Connected/Connected.enhancers';
import { ExternalSourcesConfigs } from '../../../../../containers/FilesImporter/constants/Sources';
import { withFolderPath } from '../../../../../utils/hoc/withFolderPath';
import { withItemsLoader } from '../../../../../utils/hoc/withItemsLoader';
import { withItemsReducer } from '../../../../../utils/hoc/withItemsReducer';
import { withMediaManagerSDK } from '../../../../../utils/hoc/withMediaManagerSDK';
import { withMediaTypes } from '../../../../../utils/hoc/withMediaTypes';
import { withMMGRSettings } from '../../../../../utils/hoc/withMMGRSettings';
import { IMMGRSettingsProps } from '../../../../../utils/hoc/withMMGRSettings/withMMGRSettings.types';
import { IMediaManagerSDKRequestOptions, MediaManagerSDKFolder } from '../../../../../utils/media-manager-sdk';
import { decodeWixSiteFolderId, isSiteFilesRootFolderId } from '../../../../../utils/media-manager-sdk/items';
import { IInner, IOuter, IState, TStateUpdaters } from './SiteFilesViewer.types';

export const enhance = compose<IInner, IOuter>(
  setPropTypes({
    fileType: string.isRequired,
  }),
  setDisplayName('SiteFilesViewerEnhancers'),
  withMMGRSettings,
  withStateHandlers<IState, TStateUpdaters, IMMGRSettingsProps>(
    ({ mmgrSettings }) => ({
      siteMediaToken: mmgrSettings.siteMediaToken,
    }),
    {
      updateSiteMediaToken: () => (siteMediaToken) => ({ siteMediaToken }),
    },
  ),
  withMediaTypes,
  withPropsForFolderPath,
  withFolderPath({
    validateFolderIdIfCanGetFolderInfo: (folderId, props) => {
      const siteFolder = propOr<any, MediaManagerSDKFolder>(null, 'siteFolder', props);
      const decodedFolderId = decodeWixSiteFolderId(folderId);
      const isItSiteRootFolder = decodedFolderId && isSiteFilesRootFolderId(decodedFolderId.id);

      return { isValid: !isItSiteRootFolder, fallbackFolder: isItSiteRootFolder ? siteFolder : null };
    },
  }),
  withMediaManagerSDK(),
  withItemsLoader(
    ({ source, dynamicLoaderOptions, searchQuery, mediaType, siteMediaToken }) => ({
      loaderOptions: {
        searchQuery,
        ...path<IMediaManagerSDKRequestOptions>([source, 'loaderOptions'], ExternalSourcesConfigs),
        mediaType,
        ...dynamicLoaderOptions,
        siteMediaToken,
      },
    }),
    ['source', 'dynamicLoaderOptions', 'searchQuery', 'mediaType', 'siteMediaToken', 'isSearch'],
  ),
  withItemsReducer,
);
